import { PersonaRequestBody } from './PersonaRequestBody';

/**
 * @public
 */
export interface GetModelChildrenRequestBody extends PersonaRequestBody {
  Models: string;
}
